export const USER_ACCESS_ALL_MACHINES = 'all_machines';
export const USER_ACCESS_SELECTED_MACHINES = 'selected_machines';
export const USER_ACCESS_SELECTED_MACHINE_TYPES = 'selected_machine_types';
export const USER_ACCESS_AUTOLOGIN = 'autologin';


export type UserMachineAccessMode =
  | typeof USER_ACCESS_ALL_MACHINES
  | typeof USER_ACCESS_SELECTED_MACHINES
  | typeof USER_ACCESS_SELECTED_MACHINE_TYPES
  | typeof USER_ACCESS_AUTOLOGIN;

export function resolveImageUrl(url?: string | null): string {
  if (!url) return '';
  const trimmed = url.trim();
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }

  let port = '5000';
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DATABASE_CONTROLLER_PORT != null) {
    port = process.env.REACT_APP_DATABASE_CONTROLLER_PORT;
  }

  const isSecure = typeof window !== 'undefined' && window.location?.protocol === 'https:';
  const hostname = typeof window !== 'undefined' && window.location?.hostname ? window.location.hostname : 'localhost';
  const baseUrl = isSecure ? '/api/' : `http://${hostname}:${port}/`;
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const cleanUrl = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${base}${cleanUrl}`;
}



export interface MapOverlayConfig {
  enabled: boolean;
  imageUrl: string;
  topleft: [number, number];   // [lat, lng]
  topright: [number, number];  // [lat, lng]
  bottomleft: [number, number]; // [lat, lng]
  opacity?: number;
  locked?: boolean;
  rotation?: number;
}

export type OperationConfig = Record<string, any> & {
  DATABASE_NAME: string;
  USER_MACHINE_ACCESS_MODE: UserMachineAccessMode;
  SHIFT_TIMES: string[];
  USE_MAINTENANCE_MODULE: boolean;
  MAP_OVERLAY?: MapOverlayConfig | null;
};

export const USER_MACHINE_ACCESS_MODES: { value: UserMachineAccessMode; label: string }[] = [
  {
    value: USER_ACCESS_ALL_MACHINES,
    label: 'Usuário libera qualquer máquina',
  },
  {
    value: USER_ACCESS_SELECTED_MACHINES,
    label: 'Usuário libera apenas máquinas selecionadas',
  },
  {
    value: USER_ACCESS_SELECTED_MACHINE_TYPES,
    label: 'Usuário libera tipos de máquina selecionados',
  },
  {
    value: USER_ACCESS_AUTOLOGIN,
    label: 'Autologin (pula o login como se não houvesse usuários)',
  },
];



export function normalizeOperationConfig(operation: Record<string, any>): OperationConfig {
  return {
    ...operation,
    DATABASE_NAME: operation.DATABASE_NAME || '',
    USER_MACHINE_ACCESS_MODE: operation.USER_MACHINE_ACCESS_MODE || USER_ACCESS_SELECTED_MACHINES,
    ACCESSED_BY: operation.ACCESSED_BY || [],
    SHIFT_TIMES: operation.SHIFT_TIMES || [],
    USE_MAINTENANCE_MODULE: operation.USE_MAINTENANCE_MODULE || false,
    MAP_OVERLAY: operation.MAP_OVERLAY || null,
  };
}

export function getUserMachineAccessHelpText(mode: UserMachineAccessMode): string {
  if (mode === USER_ACCESS_ALL_MACHINES) {
    return 'Permite que cada usuário com credencial válida dirija qualquer máquina da operação.';
  }
  if (mode === USER_ACCESS_SELECTED_MACHINE_TYPES) {
    return 'Restringe cada usuário a categorias/tipos de máquina específicos (ex: apenas Empilhadeiras).';
  }
  if (mode === USER_ACCESS_AUTOLOGIN) {
    return 'A máquina sempre iniciará automaticamente pulando a tela de login, como se não houvesse usuários cadastrados.';
  }
  return 'Restringe cada usuário às máquinas selecionadas/atribuídas na operação.';
}

